

class WebLayerManager {
    constructor() {
        this.layers = []
        this.currentBase = ""
    }
    addARCGIS(config) {
        const layer = map3d_viewer.viewer.imageryLayers.addImageryProvider(new Cesium.ArcGisMapServerImageryProvider({
            url: config.url
        }), config.layerIndex)
        layer.id = config.id
        this.layers.push(layer)
        map3d_viewer.viewer.imageryLayers.lowerToBottom(layer)
        return layer
    }
    addOSM(config) {
        const layer = map3d_viewer.viewer.imageryLayers.addImageryProvider(new Cesium.OpenStreetMapImageryProvider({
            url: config.url
        }), config.layerIndex);
        layer.id = config.id
        map3d_viewer.viewer.imageryLayers.lowerToBottom(layer)
        this.layers.push(layer)
        return layer
    }
    addWMTS(config) {
        const layer = map3d.MapAndTerrain.Map.WebMapTileServiceImageryProvider(config, config.layerIndex)
        layer.id = config.id
        this.layers.push(layer)
        map3d_viewer.viewer.imageryLayers.lowerToBottom(layer)
        return layer
    }
    addWMS(config) {
        const layer = map3d.MapAndTerrain.Map.WebMapServiceImageryProvider(config, config.layerIndex)
        layer.id = config.id
        layer.type = config.type
        this.layers.push(layer)
        return layer
    }
    addXYZ(config) {
        let lastcadindex
        map3d_viewer.viewer.imageryLayers._layers.forEach((item) => {
            if (item.type && item.type.indexOf("Geoserver-WMS") >= 0) {
                lastcadindex = item._layerIndex
            }
        })
        const layer = map3d.MapAndTerrain.Map.UrlTemplateImageryProvider(config, lastcadindex)
        layer.id = config.id
        this.layers.push(layer)
        return layer
    }
    addBing(config) {
        const layer = map3d_viewer.viewer.imageryLayers.addImageryProvider(Cesium.createWorldImagery(), config.layerIndex);
        layer.id = config.id
        this.layers.push(layer)
        map3d_viewer.viewer.imageryLayers.lowerToBottom(layer)
        return layer
    }
    // const layer = WebLayerManager.addWMTS({
    //     id: "天地图路网",
    //     url:
    //         "http://{s}.tianditu.gov.cn/cva_w/wmts?service=wmts&request=GetTile&version=1.0.0" +
    //         "&LAYER=cva&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}" +
    //         "&style=default.jpg&tk=" +
    //         "fc807b15633da50ec723817ea2d00722", //url地址
    //     layer: "img_w", //WMTS请求的层名称
    //     style: "default", //WMTS请求的样式名称
    //     format: "tiles", //MIME类型，用于从服务器检索图像
    //     tileMatrixSetID: "GoogleMapsCompatible", // 用于WMTS请求的TileMatrixSet的标识符
    //     subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"], //天地图8个服务器
    //     minimumLevel: 0, //最小层级
    //     maximumLevel: 18, //最大层级
    // });
    // map3d_viewer.viewer.imageryLayers.raiseToTop(layer);
    removeLayer(id) {
        let i
        this.layers.forEach((item, index) => {
            if (id === item.id) {
                i = index
                map3d_viewer.viewer.imageryLayers.remove(item)
            }
        })
        if (typeof i === "number") {
            this.layers.splice(i, 1)
        }
    }
}

export default new WebLayerManager()


// WEBPACK FOOTER //
// ./src/mapfunction/WebLayerManager.js